// extracted by mini-css-extract-plugin
export default {"button_wrapper":"report-error-modal_button_wrapper__kDeYl","submit_button":"report-error-modal_submit_button__dIKkz"};